export default __webpack_public_path__ + "static/media/indigenous1.6253af23.jpg";